var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-auth"},[_c('Logo',{staticClass:"page-auth__logo",attrs:{"height":80,"width":183}}),_c('FormAuth')],1)}
var staticRenderFns = []

export { render, staticRenderFns }